<template>
    <v-container>
      <div class="mb-5">
        <material-card color="primary" title="Tambah Organisasi (PAU/Fakultas/Sekolah)" class="card-wrapper">
          <v-form>
            <v-row>
              <div class="form-input mt-5 mb-3">
                <p style="color: red">* Wajib Diisi</p>
              </div>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Kode Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Kode Organisasi" 
                    required 
                    outlined 
                    v-model="formData.kodeorg"
                    @input="$v.formData.kodeorg.$touch()"
                    @blur="$v.formData.kodeorg.$touch()"
                    :error-messages="kodeorgErrors"
                  />
                </div>
                <p v-if="errorMessageKode" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Nama Organisasi (PAU/Fakultas/Sekolah)<span style="color: red">*</span></p>
                  <v-text-field 
                    dense
                    placeholder="Nama Organisasi" 
                    required 
                    outlined 
                    v-model="formData.nama"
                    @input="$v.formData.nama.$touch()"
                    @blur="$v.formData.nama.$touch()"
                    :error-messages="namaErrors"
                  />
                </div>
                <p v-if="errorMessageNama" style="color:red;">{{errorMessage}}</p>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Parent</p>
                  <v-autocomplete
                    no-data-text="Tidak ada data"
                    dense
                    outlined
                    placeholder="Pilih Organisasi Parent" 
                    v-model="formData.id_parent"
                    :items="organisasis"
                    item-text="nama"
                    item-value="id"
                    @input="$v.formData.id_parent.$touch()"
                    @blur="$v.formData.id_parent.$touch()"
                  ></v-autocomplete>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">Level</p>
                  <v-text-field
                    dense
                    required
                    outlined
                    v-model="computedLevel"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="form-input">
                  <p class="label font-weight-bold mb-1">File Stamp</p>
                  <v-file-input
                    dense
                    v-model="formData.file"
                    outlined
                    accept=".png"
                    @input="$v.formData.file.$touch()"
                    @blur="$v.formData.file.$touch()"
                    hint="File harus berformat PNG"
                    persistent-hint=true
                  >
                  </v-file-input>
                  <p v-if="errorMessageFile" style="color:red;">{{errorMessage}}</p>
                </div>
              </v-col>
              <v-col cols="12" class="text-right">
                <v-btn color="gray" dark @click="cancel()">Batal</v-btn>&nbsp;
                <v-btn color="primary" dark @click="postData()">Simpan</v-btn>&nbsp;
              </v-col>
            </v-row>
          </v-form>
        </material-card>
      </div>

    </v-container>
  </template>
  
<script>
  import { apiServer } from "../../setup-axios";
  import { minLength, maxLength, helpers, required } from "vuelidate/lib/validators";
  const textregex = helpers.regex('textregex', /^[a-zA-Z0-9 .,'()&\/-]{2,255}$/i)
  const koderegex = helpers.regex('koderegex', /^[a-zA-Z0-9]{2,255}$/i)
  export default {
    data: () => ({
      successCreate: null,
      errorMessage:"",
      errorMessageKode: false,
      errorMessageNama: false,
      errorMessageFile: false,
      file: null,
      organisasis: [],
      formData: {
        nama: "",
        kodeorg: "",
        status: true,
        file: null,
        level: null,
        id_parent: null,
      },
    }),
    mounted() {
      this.getListParent()
    },
    validations: {
      formData: {
        nama: {
          required,
          textregex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
        kodeorg: {
          required,
          koderegex,
          minLength: minLength(3),
          maxLength: maxLength(255)
        },
      }
    },
    computed: {
      computedLevel() {
        if (this.formData.id_parent) {
          const parent = this.organisasis.find(org => org.id === this.formData.id_parent);
          return parent ? parent.level + 1 : 0;
        }
        return 0;
      },
      namaErrors() {
        const errors = [];
        if (!this.$v.formData.nama.$dirty) return errors;
        !this.$v.formData.nama.required &&
        errors.push("Nama harus diisi");
        !this.$v.formData.nama.minLength &&
        errors.push("Nama minimal 3 karakter");
        !this.$v.formData.nama.maxLength &&
        errors.push("Nama maksimal 255 karakter");
        !this.$v.formData.nama.textregex &&
        errors.push("Nama hanya boleh mengandung huruf, angka, spasi, dan tanda . , ' ( ) & / -");
        
        return errors;
      },
      kodeorgErrors() {
        const errors = [];
        if (!this.$v.formData.kodeorg.$dirty) return errors;
        !this.$v.formData.kodeorg.required &&
        errors.push("Kode harus diisi");
        !this.$v.formData.kode_org.minLength &&
        errors.push("Kode minimal 3 karakter");
        !this.$v.formData.kodeorg.maxLength &&
        errors.push("Kode maksimal 255 karakter");
        !this.$v.formData.kodeorg.koderegex &&
        errors.push("Kode hanya boleh mengandung huruf dan angka");
        
        return errors;
      },
    },
    methods: {  
      getListParent() {
        apiServer
        .get("/organisasi/all")
        .then(response => {
          this.organisasis = response.data.data;
          console.log(this.organisasis)
        })
        .catch(error => {
          console.log("There was an error:", error.response); // Logs out the error
          this.isLoading = false;
        });
      },
      postData() {
        this.$v.$touch()
        if (this.$v.$anyError) {
          return
        }
        this.errorMessageKode = false
        this.errorMessageNama = false
        this.errorMessageFile = false
        let createData = new FormData()
        createData.append("Nama",this.formData.nama.trim(" "))
        createData.append("KodeOrg",this.formData.kodeorg.trim(" "))
        createData.append("Status",this.formData.status)
        createData.append("file",this.formData.file)
        createData.append("Level",this.computedLevel)
        if(this.formData.id_parent === null || this.formData.id_parent === 0){
          createData.append("IdParent",JSON.stringify({"Int64": 0,"Valid": false}))
        }else{
          createData.append("IdParent",JSON.stringify({"Int64": this.formData.id_parent,"Valid": true}))
        }
        console.log(createData)
        apiServer
            .post("/organisasi/create",createData)
            .then(response => {
              console.log("Successfully created organisasi:")
              console.log(response.data.data)
              localStorage.setItem('createSuccess', "Organisasi " + this.formData.nama + " berhasil dibuat.")
              this.$router.push("/organisasi")})
            .catch(error => {
              console.log("There was an error:", error.response); // Logs out the error
              if (error.response.data.message.includes("Kode")) {
                this.errorMessage = error.response.data.message
                this.errorMessageKode = true
              } else if (error.response.data.message.includes("Nama")) {
                this.errorMessage = error.response.data.message
                this.errorMessageNama = true
              } else if (error.response.data.message.includes("http: no such file")) {
                this.errorMessage = "File Stamp Organisasi belum diunggah"
                this.errorMessageFile = true
              }
            });
      },
      openFile() {
        window.open("", "mozillaWindow", "popup");
      },
      cancel() {
        this.$router.push('/organisasi')
      }
    }
  }
</script>
  